import { useSyncExternalStore } from 'react';

import { storage } from '../utils/local-storage';

export const subscribeToNavigationPosition = (onChange: () => void) => {
  window.addEventListener('k3x-navigation-position-change', onChange);
  window.addEventListener('storage', onChange);
  return () => {
    window.removeEventListener('k3x-navigation-position-change', onChange);
    window.removeEventListener('storage', onChange);
  };
};

export const useNavigationPosition = () => {
  const isSideNav = useSyncExternalStore(
    subscribeToNavigationPosition,
    () => storage.get('k3x_navigation_position') === 'side',
    () => false,
  );

  const setNavigationPosition = (position: 'side' | 'top') => {
    storage.set('k3x_navigation_position', position);
    window.dispatchEvent(new Event('k3x-navigation-position-change'));
  };

  return { isSideNav, setNavigationPosition };
};
